var exports = {
  "Nr": "DiscoveryGuildCard.module__card___RXJ2dW",
  "L8": "DiscoveryGuildCard.module__cardButton___RXJ2dW",
  "vK": "DiscoveryGuildCard.module__banner___RXJ2dW",
  "_e": "DiscoveryGuildCard.module__bannerImage___RXJ2dW",
  "Dw": "DiscoveryGuildCard.module__bannerScrim___RXJ2dW",
  "Kk": "DiscoveryGuildCard.module__icon___RXJ2dW",
  "rf": "DiscoveryGuildCard.module__body___RXJ2dW",
  "$": "DiscoveryGuildCard.module__titleRow___RXJ2dW",
  "fh": "DiscoveryGuildCard.module__nameText___RXJ2dW",
  "h_": "DiscoveryGuildCard.module__description___RXJ2dW",
  "qr": "DiscoveryGuildCard.module__footer___RXJ2dW",
  "dJ": "DiscoveryGuildCard.module__stat___RXJ2dW",
  "gW": "DiscoveryGuildCard.module__statDot___RXJ2dW",
  "rR": "DiscoveryGuildCard.module__statDotOnline___RXJ2dW" + " " + "DiscoveryGuildCard.module__statDot___RXJ2dW",
  "rb": "DiscoveryGuildCard.module__statDotMembers___RXJ2dW" + " " + "DiscoveryGuildCard.module__statDot___RXJ2dW",
  "KA": "DiscoveryGuildCard.module__statText___RXJ2dW",
};

module.exports = exports;
